<template>
    <section :class="css.container">
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <div :class="css.title" class="font-variable color-1 font-bold">{{ $t("GeneExpression") }}</div>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/disease/mark.png" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("GeneExpressionDescript1") }}</div>
                        <div :class="css_normalize.context">{{ $t("GeneExpressionDescript2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div class="container text-hint" :class="css.error" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
        <div class="container" :class="css.body" v-else>
            <Expression :class="css.mb40" ref="expression1" :name="$t('RNAExpression1')" type="tissue" />
            <Expression ref="expression2" :name="$t('RNAExpression2')" type="cell" />
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiTooltip } from "various-ui";
//* 内部组件
import Expression from "./component/expression/index.vue";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 插件
const route = useRoute();
const exist = ref<boolean>(true);

//* 节点
const expression1 = ref<InstanceType<typeof Expression>>();
const expression2 = ref<InstanceType<typeof Expression>>();

onMounted(() => {
    //* 请求列表
    const requests: Promise<any>[] = [];
    //* 请求数据
    requests.push(
        api.frontend("/api/gene/expression", {
            data: {
                id: route.params.id,
                sort: "group",
                type: "tissue",
            },
            error: () => expression1.value?.hidden(),
            hidden: true,
            success: (response) => {
                if (!response) expression1.value?.hidden();
                else {
                    expression1.value?.render(response);
                }
            },
        })
    );

    requests.push(
        api.frontend("/api/gene/expression", {
            data: {
                id: route.params.id,
                sort: "group",
                type: "cell",
            },
            error: () => expression2.value?.hidden(),
            hidden: true,
            success: (response) => {
                if (!response) expression2.value?.hidden();
                else {
                    expression2.value?.render(response);
                }
            },
        })
    );

    //* 批量请求
    try {
        Promise.all(requests).then((value) => {
            if (!value[0] && !value[1]) exist.value = false;
        });
    } catch {}
});
</script>
